/* ═══════════════════════════════════════════════════════════════
   Artmate PDP v2 — JavaScript
   Kalles drawer cart uyumlu · Judge.me hazır · Vanilla JS
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── Helpers ── */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];
  const fmt = (cents) => (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 });

  /* ── State ── */
  let selectedVariantId = null;
  let selectedFrame = null;
  let selectedSize = null;
  let qty = 1;
  let currentMainPrice = 0;
  let lumiVariantId = null;

  /* ══════════════════════════════════
     1. GALLERY
  ══════════════════════════════════ */
  function initGallery() {
    const strip = $('#am-gallery-main');
    const thumbsWrap = $('#am-g-thumbs');
    const counter = $('#am-g-counter');
    if (!strip) return;

    const figures = $$('figure', strip);
    const thumbBtns = $$('button', thumbsWrap);
    let current = 0;

    function goTo(idx) {
      current = idx;
      const fig = figures[idx];
      if (fig) {
        strip.scrollTo({ left: fig.offsetLeft, behavior: 'smooth' });
      }
      figures.forEach((f, i) => f.classList.toggle('am-active', i === idx));
      thumbBtns.forEach((b, i) => b.classList.toggle('active', i === idx));
      if (counter) counter.textContent = `${idx + 1} / ${figures.length}`;
    }

    // Thumb clicks
    thumbBtns.forEach((btn, i) => btn.addEventListener('click', () => goTo(i)));

    // Desktop prev/next arrow buttons
    const prevBtn = $('#am-gallery-prev');
    const nextBtn = $('#am-gallery-next');
    if (prevBtn) prevBtn.addEventListener('click', () => goTo(Math.max(0, current - 1)));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(Math.min(figures.length - 1, current + 1)));

    // Swipe — touch (mobile)
    let touchStartX = 0;
    strip.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
    strip.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 50) {
        goTo(dx < 0 ? Math.min(current + 1, figures.length - 1) : Math.max(current - 1, 0));
      }
    }, { passive: true });

    // Mouse drag — desktop
    let mouseStartX = 0, mouseDragging = false;
    strip.addEventListener('mousedown', e => {
      mouseStartX = e.clientX; mouseDragging = true;
      strip.style.cursor = 'grabbing';
      e.preventDefault();
    });
    window.addEventListener('mousemove', e => {
      if (!mouseDragging) return;
      strip.scrollLeft += (mouseStartX - e.clientX) * 0.4;
    });
    window.addEventListener('mouseup', e => {
      if (!mouseDragging) return;
      mouseDragging = false;
      strip.style.cursor = 'grab';
      const dx = e.clientX - mouseStartX;
      if (Math.abs(dx) > 40) {
        goTo(dx < 0 ? Math.min(current + 1, figures.length - 1) : Math.max(current - 1, 0));
      }
    });
    strip.style.cursor = 'grab';

    // Scroll-based counter update (mobile)
    strip.addEventListener('scroll', () => {
      const idx = Math.round(strip.scrollLeft / strip.offsetWidth);
      if (idx !== current) {
        current = idx;
        thumbBtns.forEach((b, i) => b.classList.toggle('active', i === idx));
        if (counter) counter.textContent = `${idx + 1} / ${figures.length}`;
      }
    }, { passive: true });

    goTo(0);
  }

  /* ══════════════════════════════════
     1b. GALLERY — switch to image by ID
  ══════════════════════════════════ */
  function switchGalleryToImage(imgId) {
    const strip = $('#am-gallery-main');
    if (!strip) return;
    const figures = $$('figure', strip);
    const idx = figures.findIndex(f => f.dataset.imageId == imgId || f.dataset.imgId == imgId);
    if (idx >= 0) {
      // reuse goTo from initGallery scope — trigger via thumb click or direct
      const thumbsWrap = $('#am-g-thumbs');
      const thumbBtns = thumbsWrap ? $$('button', thumbsWrap) : [];
      if (thumbBtns[idx]) {
        thumbBtns[idx].click();
      } else {
        // fallback: scroll to figure
        figures.forEach((f, i) => f.classList.toggle('am-active', i === idx));
        strip.scrollTo({ left: figures[idx].offsetLeft, behavior: 'smooth' });
      }
    }
  }

  /* ══════════════════════════════════
     2. VARIANT SELECTOR (Çerçeve + Ölçü)
     Shopify variant matching
  ══════════════════════════════════ */
  function initVariants() {
    const frameSwatches = $$('.am-frame-swatch');
    const sizeTiles = $$('.am-size-tile');
    const frameVal = $('#am-frame-val');
    const sizeVal = $('#am-size-val');

    // Read initial selections
    const firstFrame = frameSwatches.find(s => s.classList.contains('am-selected'));
    const firstSize = sizeTiles.find(s => s.classList.contains('am-selected'));
    if (firstFrame) selectedFrame = firstFrame.dataset.option1;
    if (firstSize) selectedSize = firstSize.dataset.option2;

    // Size tile hint fiyatlarını seçili frame'e göre güncelle
    // Eğer frame+size kombinasyonu yoksa tile'ı unavailable yap
    function updateSizeTilePrices(frame) {
      if (!window.__amHasFrame) return;
      const variants = window.__amVariants || [];
      let needReselect = false;
      sizeTiles.forEach(tile => {
        const size = tile.dataset.option2;
        const v = variants.find(vv => vv.option1 === frame && vv.option2 === size);
        if (!v) {
          tile.classList.add('am-unavailable');
          tile.disabled = true;
          if (tile.classList.contains('am-selected')) {
            tile.classList.remove('am-selected');
            needReselect = true;
          }
          return;
        }
        tile.classList.remove('am-unavailable');
        tile.disabled = false;
        const priceCents = Math.round(parseFloat(v.price));
        const priceTL = Math.round(priceCents / 100);
        const formatted = priceTL.toLocaleString('tr-TR') + '₺';
        tile.dataset.price = priceCents;
        const hint = tile.querySelector('.am-size-hint');
        if (hint) hint.textContent = size + ' · ' + formatted;
      });
      // Seçili boyut unavailable olduysa ilk uygun tile'ı seç
      if (needReselect) {
        const firstAvail = sizeTiles.find(t => !t.classList.contains('am-unavailable'));
        if (firstAvail) firstAvail.click();
      }
    }

    frameSwatches.forEach(swatch => {
      swatch.addEventListener('click', () => {
        frameSwatches.forEach(s => s.classList.remove('am-selected'));
        swatch.classList.add('am-selected');
        selectedFrame = swatch.dataset.option1;
        if (frameVal) frameVal.textContent = selectedFrame;
        // Switch gallery to this frame's image; Çerçevesiz → 1. fotoğrafa dön
        const imgId = swatch.dataset.imgId;
        if (imgId) {
          switchGalleryToImage(imgId);
        } else {
          const firstThumb = document.querySelector('#am-g-thumbs button');
          if (firstThumb) firstThumb.click();
        }
        // Size tile fiyatlarını güncelle
        updateSizeTilePrices(selectedFrame);
        // Direct price update (guaranteed): find variant matching new frame + current size
        directPriceUpdate({ frame: selectedFrame, size: selectedSize });
        matchVariant(); // may refine if variant found
        updateStickyVariant();
        updateLumiVisibility();
        // Sync bundle main image from active gallery figure
        setTimeout(() => {
          const activeImg = document.querySelector('#am-gallery-main figure.am-active img');
          const bundleImg = document.getElementById('am-bundle-main-img');
          if (activeImg && bundleImg) bundleImg.src = activeImg.src;
        }, 120);
      });
    });

    sizeTiles.forEach(tile => {
      if (tile.classList.contains('am-unavailable')) return;
      tile.addEventListener('click', () => {
        sizeTiles.forEach(t => t.classList.remove('am-selected'));
        tile.classList.add('am-selected');
        selectedSize = tile.dataset.option2;
        if (sizeVal) sizeVal.textContent = selectedSize;
        // Direct price update (guaranteed): use tile's data-price attribute
        const tilePrice = parseInt(tile.dataset.price, 10);
        if (tilePrice) directPriceUpdate({ price: tilePrice });
        matchVariant(); // may refine with more accurate frame-aware price
        updateStickyVariant();
        updateLumiForSize(selectedSize);
      });
    });

    matchVariant();
    updateLumiVisibility(); // set initial Lumi row visibility
  }

  /* Direct price update — called immediately on tile/swatch click.
     Uses data-price attribute (from Liquid) or scans window.__amVariants.
     matchVariant() runs afterwards and may override with more accurate value. */
  function directPriceUpdate({ price, frame, size } = {}) {
    // Her zaman tam varyantı bul — compare_at_price için
    const variants = window.__amVariants || [];
    const hasFrame = !!window.__amHasFrame;
    const f = frame || selectedFrame;
    const s = size  || selectedSize;
    const v = variants.find(vv => {
      const o1 = f ? vv.option1 === f : true;
      const sizeField = hasFrame ? vv.option2 : vv.option1;
      const o2 = s ? sizeField === s : true;
      return o1 && o2;
    });
    const p   = (v && v.price) || price;
    const cap = v ? (v.compare_at_price || null) : null;
    if (!p) return;
    currentMainPrice = p;
    updatePrice(p, cap);
    updateInstallments(p);
    updateStickyPrice(p, cap);
    updateBundleTotal();
    document.dispatchEvent(new CustomEvent('artmate:variant:changed', { detail: { variant: { price: p, compare_at_price: cap } } }));
  }

  function matchVariant() {
    const variants = window.__amVariants || [];
    const hasFrame = !!window.__amHasFrame;
    const sf = selectedFrame ? selectedFrame.trim() : null;
    const ss = selectedSize  ? selectedSize.trim()  : null;
    const match = variants.find(v => {
      // Frame products: option1=frame, option2=size
      // No-frame products: option1=size (stored in selectedSize / data-option2 on tile)
      const o1 = sf ? v.option1.trim() === sf : true;
      const sizeField = hasFrame ? v.option2 : v.option1;
      const o2 = ss ? sizeField.trim() === ss : true;
      return o1 && o2 && v.available;
    }) || variants.find(v => {
      const o1 = sf ? v.option1.trim() === sf : true;
      const sizeField = hasFrame ? v.option2 : v.option1;
      const o2 = ss ? sizeField.trim() === ss : true;
      return o1 && o2;
    });

    if (match) {
      selectedVariantId = match.id;
      currentMainPrice = match.price;
      updatePrice(match.price, match.compare_at_price);
      updateInstallments(match.price);
      updateStickyPrice(match.price, match.compare_at_price);
      updateStockAlert(match);
      // Dispatch event so external sections (e.g. PayTR table) can react
      document.dispatchEvent(new CustomEvent('artmate:variant:changed', { detail: { variant: match } }));

      const addBtn = $('#am-add-to-cart');
      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available ? 'Sepete Ekle' : 'Tükendi';
      }

      // Sync bundle seçeceğiniz tablo info
      const bundleVariantEl = document.getElementById('am-bundle-variant');
      if (bundleVariantEl) {
        bundleVariantEl.textContent = [selectedFrame, selectedSize].filter(Boolean).join(' · ');
      }
      const bundlePriceEl = document.getElementById('am-bundle-main-price');
      if (bundlePriceEl) bundlePriceEl.textContent = fmt(match.price) + ' ₺';

      // Bundle liste fiyatı (compare_at_price)
      const bundleWasEl = document.getElementById('am-bundle-main-price-was');
      if (bundleWasEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          bundleWasEl.textContent = fmt(match.compare_at_price) + ' ₺';
          bundleWasEl.style.display = '';
        } else {
          bundleWasEl.style.display = 'none';
        }
      }

      updateBundleTotal();
    }
  }

  function updatePrice(price, compareAtPrice) {
    const priceEl = $('#am-price-now');
    const wasEl = $('#am-price-was');
    const saveEl = $('#am-price-save');
    if (priceEl) priceEl.innerHTML = fmt(price) + '<small style="font-size:.6em;font-weight:700;margin-left:2px">₺</small>';
    if (wasEl && compareAtPrice && compareAtPrice > price) {
      wasEl.textContent = fmt(compareAtPrice) + '₺';
      wasEl.style.display = '';
    } else if (wasEl) {
      wasEl.style.display = 'none';
    }
    if (saveEl && compareAtPrice && compareAtPrice > price) {
      const saved = compareAtPrice - price;
      saveEl.textContent = fmt(saved) + '₺ TASARRUF';
      saveEl.style.display = '';
    } else if (saveEl) {
      saveEl.style.display = 'none';
    }
  }

  function updateInstallments() {
    // Skeleton göster — gerçek değerler PayTR'den gelecek
    $$('.am-installment-amt').forEach(el => {
      el.textContent = '';
      el.classList.add('am-loading');
    });
  }

  /* Ölçü Rehberi accordion item'ını aç ve scroll et */
  window.amOpenOlcuRehberi = function () {
    const item = document.getElementById('am-acc-olcu');
    if (!item) return;
    // Diğer açık itemları kapat
    $$('.am-acc-item.open').forEach(i => i.classList.remove('open'));
    item.classList.add('open');
    // Kısa gecikme ile scroll — DOM güncellenmesi için bekle
    setTimeout(() => {
      item.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 60);
  };

  /* Lumi satırını çerçeve seçimine göre göster/gizle/uyarı */
  function updateLumiVisibility() {
    const lumiRow = document.getElementById('am-bundle-lumi-row');
    if (!lumiRow) return;

    // Çerçeve seçeneği hiç yoksa (is_frame_option = false) → satırı tamamen gizle
    const hasFrameOption = !!document.getElementById('am-frames');
    if (!hasFrameOption) {
      lumiRow.style.display = 'none';
      return;
    }

    // Çerçeve seçeneği var: satır her zaman görünür, ama seçime göre uyarı/boyutlar toggle
    lumiRow.style.display = '';
    const isFrameless = selectedFrame && (
      selectedFrame === 'Çerçevesiz' ||
      selectedFrame.toLowerCase().replace(/ç/g, 'c').replace(/i/g, 'i') === 'cercevesiz'
    );
    const warning = document.getElementById('am-lumi-frame-warning');
    const lumiSizes = document.getElementById('am-lumi-sizes');
    if (warning) warning.style.display = isFrameless ? 'none' : 'flex';
    if (lumiSizes) lumiSizes.style.display = isFrameless ? '' : 'none';
    updateBundleTotal();
  }

  /* Ürün boyutuna göre Lumi tile'ı seç — data-lumi-size ile tam eşleşme */
  function updateLumiForSize(sizeStr) {
    if (!sizeStr) return;
    const tiles = $$('.am-lumi-tile');
    if (!tiles.length) return;
    // Önce birebir eşleşme dene (e.g. "72x46 cm" === "72x46 cm")
    let tile = tiles.find(t => t.dataset.lumiSize === sizeStr);
    // Yoksa ilk boyut parçasıyla eşleştir (e.g. "72x46" içinde "72")
    if (!tile) {
      const prefix = sizeStr.split(/[\sx]/)[0];
      tile = tiles.find(t => t.dataset.lumiSize && t.dataset.lumiSize.split(/[\sx]/)[0] === prefix);
    }
    // Son çare: ilk tile
    if (!tile) tile = tiles[0];
    tiles.forEach(t => t.classList.remove('am-lumi-selected'));
    tile.classList.add('am-lumi-selected');
    syncLumiPrice(tile);
    updateBundleTotal();
  }

  function syncLumiPrice(tile) {
    if (!tile) return;
    const priceRaw = parseInt(tile.dataset.lumiPrice) || 0;
    const el = document.getElementById('am-bundle-lumi-price');
    if (el) el.textContent = priceRaw ? (priceRaw / 100).toLocaleString('tr-TR') + ' ₺' : '— ₺';
    // Varyant ID'sini güncelle
    lumiVariantId = tile.dataset.lumiVariantId ? parseInt(tile.dataset.lumiVariantId) : null;
  }

  /* Çerçeve bölümüne scroll + highlight */
  /* "Işığı gör" pill — Aplik Işık demo bölümüne scroll */
  window.amScrollToSconceDemo = function () {
    const el = document.querySelector('.am-sconce-demo');
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  window.amScrollToFrames = function () {
    const el = document.getElementById('am-frames');
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: 'smooth' });
    el.classList.add('am-highlight-pulse');
    setTimeout(() => el.classList.remove('am-highlight-pulse'), 1400);
  };

  /* Lumi tile seçimi — Liquid onclick'ten çağrılır */
  window.amLumiSelect = function (btn) {
    $$('.am-lumi-tile').forEach(b => b.classList.remove('am-lumi-selected'));
    btn.classList.add('am-lumi-selected');
    syncLumiPrice(btn);
    updateBundleTotal();
    // Ana ürün boyutunu da sync et — karşılıklı bağlantı
    const lumiSize = btn.dataset.lumiSize;
    if (lumiSize) {
      const matchTile = $$('.am-size-tile').find(t => t.dataset.option2 === lumiSize && !t.classList.contains('am-unavailable'));
      if (matchTile) matchTile.click();
    }
  };

  /* Toplam fiyatı dinamik hesapla ve göster */
  function updateBundleTotal() {
    const totalEl = document.getElementById('am-bundle-total');
    if (!totalEl) return;
    let total = currentMainPrice;
    if (!total) return;

    // Lumi — görünür + toggle seçili + uyarı yoksa ekle
    const lumiRow = document.getElementById('am-bundle-lumi-row');
    const lumiWarning = document.getElementById('am-lumi-frame-warning');
    const lumiRowVisible = lumiRow && lumiRow.style.display !== 'none';
    const lumiToggled   = lumiRow && lumiRow.classList.contains('am-bundle-selected');
    const warnVisible   = lumiWarning && lumiWarning.style.display !== 'none';
    if (lumiRowVisible && lumiToggled && !warnVisible) {
      const selTile = document.querySelector('.am-lumi-tile.am-lumi-selected');
      if (selTile) total += parseInt(selTile.dataset.lumiPrice) || 0;
    }

    // Bakım seti — seçiliyse ekle (449₺)
    const careRow = document.getElementById('am-bundle-care-row');
    if (careRow && careRow.classList.contains('am-bundle-selected')) {
      total += 44900;
    }

    totalEl.textContent = (total / 100).toLocaleString('tr-TR') + ' ₺';
  }
  window.updateBundleTotal = updateBundleTotal;

  function updateStickyVariant() {
    const el = $('#am-sticky-variant');
    if (el) el.textContent = [selectedFrame, selectedSize].filter(Boolean).join(' · ');
  }

  function updateStickyPrice(price, compareAtPrice) {
    const priceEl = $('#am-sticky-price-now');
    const wasEl = $('#am-sticky-price-was');
    if (priceEl) priceEl.textContent = fmt(price) + '₺';
    if (wasEl && compareAtPrice && compareAtPrice > price) {
      wasEl.textContent = fmt(compareAtPrice) + '₺';
    }
  }

  /* ══════════════════════════════════
     3. QTY STEPPER
  ══════════════════════════════════ */
  function initQty() {
    const input = $('#am-qty-input');
    const minus = $('#am-qty-minus');
    const plus = $('#am-qty-plus');
    if (!input) return;

    minus && minus.addEventListener('click', () => {
      qty = Math.max(1, qty - 1);
      input.value = qty;
    });
    plus && plus.addEventListener('click', () => {
      qty = qty + 1;
      input.value = qty;
    });
    input.addEventListener('change', () => {
      qty = Math.max(1, parseInt(input.value) || 1);
      input.value = qty;
    });
  }

  /* ══════════════════════════════════
     4. ADD TO CART (Kalles drawer)
  ══════════════════════════════════ */
  function initAddToCart() {
    const btn = $('#am-add-to-cart');
    const stickyBtn = $('#am-sticky-add');
    const buyBtn = $('#am-buy-now');

    function doAddToCart(e) {
      e && e.preventDefault();
      if (!selectedVariantId) return;
      const btn = e ? e.currentTarget : document.getElementById('am-add-to-cart');
      const origText = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Ekleniyor...'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: qty })
      })
      .then(r => r.json())
      .then(() => {
        if (btn) { btn.disabled = false; btn.innerHTML = origText; }
        // Kalles drawer cart açma — birden fazla pattern dene
        openKallesDrawer();
      })
      .catch(() => {
        if (btn) { btn.disabled = false; btn.innerHTML = origText; }
        window.location.href = '/cart';
      });
    }

    btn && btn.addEventListener('click', doAddToCart);
    stickyBtn && stickyBtn.addEventListener('click', doAddToCart);

    buyBtn && buyBtn.addEventListener('click', (e) => {
      e.preventDefault();
      if (!selectedVariantId) return;
      buyBtn.disabled = true;
      buyBtn.textContent = 'Yönlendiriliyor...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: selectedVariantId, quantity: qty })
      })
      .then(r => r.json())
      .then(() => { window.location.href = '/checkout'; })
      .catch(() => {
        buyBtn.disabled = false;
        buyBtn.innerHTML = '<svg width="14" height="14" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 10l3 3 7-7"/></svg> Hızlı Satın Al';
        window.location.href = `/cart/${selectedVariantId}:${qty}`;
      });
    });
  }

  function openKallesDrawer() {
    // Kalles v4.x cart events — try multiple approaches
    try {
      // Pattern 1: Kalles custom event
      document.dispatchEvent(new CustomEvent('theme:cart:open'));
    } catch(e) {}
    try {
      // Pattern 2: Kalles global cart update
      document.dispatchEvent(new CustomEvent('theme:cart:change'));
    } catch(e) {}
    try {
      // Pattern 3: XB drawer (used on Artmate)
      if (window.xb && window.xb.cart) window.xb.cart.open();
    } catch(e) {}
    try {
      // Pattern 4: Kalles CartDrawer object
      if (window.theme && window.theme.CartDrawer) window.theme.CartDrawer.open();
    } catch(e) {}
    // Pattern 5: click the hidden cart trigger button
    const cartTrigger = document.querySelector('[data-cart-toggle], .js-drawer-open-cart, #cart-icon-bubble');
    if (cartTrigger) {
      setTimeout(() => cartTrigger.click(), 100);
    }
  }

  /* ══════════════════════════════════
     5. STICKY CTA
  ══════════════════════════════════ */
  function initStickyCta() {
    const sticky = $('#am-sticky-cta');
    const wp    = $('#am-wa-wrap');
    const atcSection = $('#am-qty-cta-section');
    if (!sticky || !atcSection) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        // Sadece section aşağıdan kaybolunca göster (yukarıda değil)
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('am-visible', show);
        // WP butonu: sticky açıkken yukarı çık
        if (wp) wp.classList.toggle('am-wp-above-sticky', show);
      },
      { threshold: 0 }
    );
    observer.observe(atcSection);
  }

  /* ══════════════════════════════════
     6. ACCORDION
  ══════════════════════════════════ */
  function initAccordion() {
    $$('.am-acc-trigger').forEach(trigger => {
      trigger.addEventListener('click', () => {
        const item = trigger.closest('.am-acc-item');
        const isOpen = item.classList.contains('open');
        // Close all
        $$('.am-acc-item.open').forEach(i => i.classList.remove('open'));
        // Toggle clicked
        if (!isOpen) item.classList.add('open');
      });
    });
  }

  /* ══════════════════════════════════
     7. LIVE SIGNAL (random but realistic)
  ══════════════════════════════════ */
  function initLiveSignal() {
    const countEl = $('#am-live-count');
    if (!countEl) return;
    let base = 3 + Math.floor(Math.random() * 8); // 3–10 başlangıç
    countEl.textContent = base;
    setInterval(() => {
      base += Math.random() > 0.5 ? 1 : -1;
      base = Math.max(3, Math.min(base, 15));
      countEl.textContent = base;
    }, 8000);
  }

  function initScarcity() { /* devre dışı */ }

  function updateStockAlert(variant) {
    // Gerçek stok takibi varsa override et
    const el = document.getElementById('am-stock-alert');
    const txt = document.getElementById('am-stock-text');
    if (!el || !txt) return;
    const qty = variant.inventory_quantity;
    const managed = variant.inventory_management === 'shopify';
    if (managed && qty > 0 && qty <= 9) {
      txt.textContent = qty <= 3
        ? `Son ${qty} ürün kaldı! Kaçırmayın.`
        : `Az stok — yalnızca ${qty} ürün kaldı`;
      el.style.display = 'flex';
    }
    // Stok takibi yoksa psikolojik versiyon zaten görünüyor, dokunma
  }

  /* ══════════════════════════════════
     7c. COUNTDOWN (gece yarısına kadar)
  ══════════════════════════════════ */
  function initCountdown() {
    const el = document.getElementById('am-countdown-timer');
    if (!el) return;
    function tick() {
      const now = new Date();
      const midnight = new Date();
      midnight.setHours(23, 59, 59, 999);
      const diff = midnight - now;
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      el.textContent = `${String(h).padStart(2,'0')}:${String(m).padStart(2,'0')}:${String(s).padStart(2,'0')}`;
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ══════════════════════════════════
     8. BUNDLE ADD + CARE KIT TOGGLE
  ══════════════════════════════════ */
  function initBundle() {
    // İlk seçili Lumi tile fiyat + varyant ID'sini yükle
    const firstLumiTile = document.querySelector('.am-lumi-tile.am-lumi-selected');
    if (firstLumiTile) syncLumiPrice(firstLumiTile);

    // Lumi toggle
    const lumiToggle = document.getElementById('am-lumi-toggle');
    if (lumiToggle) {
      lumiToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const row = document.getElementById('am-bundle-lumi-row');
        if (row) row.classList.toggle('am-bundle-selected');
        updateBundleTotal();
      });
    }

    // Aplik ışık demo (Lumi "Işık her şeyi değiştirir" bölümü)
    const sconceSwitch = document.getElementById('am-sconce-switch');
    if (sconceSwitch) {
      const imgOn  = document.getElementById('am-sconce-img-on');
      const imgOff = document.getElementById('am-sconce-img-off');
      const labels = document.querySelectorAll('.am-sconce-toggle-label');
      const setSconceState = (on) => {
        sconceSwitch.setAttribute('aria-checked', on ? 'true' : 'false');
        if (imgOn) imgOn.classList.toggle('am-sconce-img--on', on);
        if (imgOff) imgOff.classList.toggle('am-sconce-img--on', !on);
        labels.forEach(l => l.classList.toggle('am-sconce-label-active', l.dataset.state === (on ? 'on' : 'off')));
      };
      setSconceState(true);
      sconceSwitch.addEventListener('click', () => {
        setSconceState(sconceSwitch.getAttribute('aria-checked') !== 'true');
      });
    }
    const sconceCta = document.getElementById('am-sconce-cta');
    if (sconceCta) {
      sconceCta.addEventListener('click', () => {
        const card = document.getElementById('am-sconce-card');
        if (card) {
          const top = card.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top, behavior: 'smooth' });
          card.classList.add('am-highlight-pulse');
          setTimeout(() => card.classList.remove('am-highlight-pulse'), 1400);
        }
      });
    }

    // Şarjlı Aplik Işık — bağımsız kart, kendi sepete ekleme
    const sconceCardBtn = document.getElementById('am-sconce-card-add');
    if (sconceCardBtn) {
      sconceCardBtn.addEventListener('click', () => {
        const vid = window.__amSconceVariantId;
        if (!vid) return;
        const origHTML = sconceCardBtn.innerHTML;
        sconceCardBtn.disabled = true;
        sconceCardBtn.textContent = 'Ekleniyor...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
        })
        .then(r => r.json())
        .then(() => {
          sconceCardBtn.disabled = false;
          sconceCardBtn.innerHTML = origHTML;
          openKallesDrawer();
        })
        .catch(() => {
          sconceCardBtn.disabled = false;
          sconceCardBtn.innerHTML = origHTML;
        });
      });
    }

    // Bakım Seti toggle
    const careToggle = document.getElementById('am-care-toggle');
    if (careToggle) {
      careToggle.addEventListener('click', (e) => {
        e.stopPropagation();
        const row = document.getElementById('am-bundle-care-row');
        if (row) row.classList.toggle('am-bundle-selected');
        updateBundleTotal();
      });
    }

    // İlk yükleme toplam hesabı
    updateBundleTotal();

    // Bundle add button — seçili tüm ürünleri sepete ekle
    const bundleBtn = $('#am-bundle-add');
    if (!bundleBtn) return;
    bundleBtn.addEventListener('click', () => {
      if (!selectedVariantId) return;

      // Her zaman ana ürün eklenir
      const items = [{ id: selectedVariantId, quantity: qty }];

      // Lumi — toggle seçili + görünür + uyarı yok + varyant ID var
      const lumiRow     = document.getElementById('am-bundle-lumi-row');
      const lumiWarning = document.getElementById('am-lumi-frame-warning');
      const lumiVisible = lumiRow && lumiRow.style.display !== 'none';
      const lumiOn      = lumiRow && lumiRow.classList.contains('am-bundle-selected');
      const warnOn      = lumiWarning && lumiWarning.style.display !== 'none';
      if (lumiVisible && lumiOn && !warnOn && lumiVariantId) {
        // Üçlü sette 3 panel var — Lumi de 3 ayrı fiziksel çerçeve demek (window.__amLumiQty
        // sadece artmate-pdp-uclu.liquid'de 3 olarak set edilir, diğer tüm PDP'lerde 1 kalır).
        items.push({ id: lumiVariantId, quantity: window.__amLumiQty || 1 });
      }

      // Bakım Seti — toggle seçili + varyant ID var
      const careRow  = document.getElementById('am-bundle-care-row');
      const careVid  = window.__amCareVariantId;
      if (careRow && careRow.classList.contains('am-bundle-selected') && careVid) {
        items.push({ id: careVid, quantity: 1 });
      }

      const origHTML = bundleBtn.innerHTML;
      bundleBtn.disabled = true;
      bundleBtn.textContent = 'Ekleniyor...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(r => r.json())
      .then(() => {
        bundleBtn.disabled = false;
        bundleBtn.innerHTML = origHTML;
        openKallesDrawer();
      })
      .catch(() => {
        bundleBtn.disabled = false;
        bundleBtn.innerHTML = origHTML;
        window.location.href = '/cart';
      });
    });
  }

  /* ══════════════════════════════════
     9. PAYTR REAL INSTALLMENT SYNC
     PayTR big table yüklenince gerçek
     taksit tutarlarını küçük kartlara yaz
  ══════════════════════════════════ */
  document.addEventListener('paytr:installments:ready', (e) => {
    const amounts = e.detail && e.detail.amounts;
    if (!amounts || !amounts.length) return;
    const amts = $$('.am-installment-amt');
    amounts.forEach((amt, i) => {
      if (!amts[i]) return;
      amts[i].classList.remove('am-loading');
      amts[i].textContent = amt;
    });
  });

  /* ── Tahmini Teslimat Şeridi — gerçek iş günü mantığı ── */
  function initEtaTimeline() {
    const el = document.getElementById('am-eta');
    if (!el) return;

    function addBusinessDays(date, days) {
      const d = new Date(date);
      let added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        const dow = d.getDay();
        if (dow !== 0 && dow !== 6) added++;
      }
      return d;
    }

    function getEffectiveStart() {
      const now = new Date();
      const dow = now.getDay();
      const isWeekend = dow === 0 || dow === 6;
      const afterCutoff = now.getHours() >= 14;
      if (isWeekend || afterCutoff) {
        const d = new Date(now);
        do { d.setDate(d.getDate() + 1); } while (d.getDay() === 0 || d.getDay() === 6);
        return d;
      }
      return now;
    }

    function fmtTR(d) {
      return d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
    }

    const now = new Date();
    const effectiveStart = getEffectiveStart();
    const readyDate = addBusinessDays(effectiveStart, 4);   // 4 iş günü üretim
    const deliverMin = addBusinessDays(readyDate, 1);        // 1 iş günü kargo (yakın)
    const deliverMax = addBusinessDays(readyDate, 2);        // 2 iş günü kargo (uzak mesafe)

    const orderedEl = document.getElementById('am-eta-ordered');
    const readyEl = document.getElementById('am-eta-ready');
    const deliveredEl = document.getElementById('am-eta-delivered');
    if (orderedEl) orderedEl.textContent = fmtTR(now);
    // Hazırlık aralığını bugünden değil gerçek üretim başlangıcından göster —
    // hafta sonu/kesim saati yüzünden "bugün" ile arada boşta geçen günler
    // aralığı gereksiz genişletip müşteriye ürkütücü görünmesin.
    if (readyEl) readyEl.textContent = fmtTR(effectiveStart) + ' – ' + fmtTR(readyDate);
    // Tek "en geç" tarihi göster, geniş 2 tarihli aralık yerine — daha az korkutucu.
    if (deliveredEl) deliveredEl.textContent = 'En geç ' + fmtTR(deliverMax);
  }

  /* ── Init ── */
  document.addEventListener('DOMContentLoaded', () => {
    initEtaTimeline();
    initGallery();
    initVariants();
    initQty();
    initAddToCart();
    initStickyCta();
    initAccordion();
    initLiveSignal();
    initBundle();
    initScarcity();
    initCountdown();
    initReviewFallback();
  });

  /* Judge.me yüklendikten sonra yıldız varsa fallback linki gizle */
  function initReviewFallback() {
    const fallback = document.querySelector('.am-review-link--fallback');
    if (!fallback) return;
    const badge = document.querySelector('.jdgm-preview-badge');
    if (!badge) return;

    const check = () => {
      // Yıldız render olduysa (rating metni veya yıldız el var) fallback'i gizle
      const hasRating = badge.querySelector('.jdgm-prev-badge__rating, .jdgm--on, [class*="rating"]');
      if (hasRating) fallback.style.display = 'none';
    };

    // Judge.me async yüklenir, MutationObserver ile yakala
    const obs = new MutationObserver(() => { check(); });
    obs.observe(badge, { childList: true, subtree: true });
    // İlk render için kısa gecikme de ekle
    setTimeout(check, 800);
  }

})();
